'use strict';
define(['./util', './analytics'], function (Utils, analytics) {

    function brandNewslettercomponent() {
        this.inputFieldElement = document.querySelector('.navfooter-brand-newsletter-signup__form__input');
        this.emailErrormsg = document.querySelector('.navfooter-brand-newsletter-signup-errormsg');
        this.alertIcon = document.querySelector('.navfooter-brand-newsletter-signup-alerticon.navfooter-alertdiv');
        this.emailSubmitButton = document.querySelector('.navfooter-brand-newsletter-signup__form__submit');
        this.validateInputField = this.validateInputField.bind(this);
        this.validateInputFieldOnFocus = this.validateInputFieldOnFocus.bind(this);
        this.formstoreId = '';
        this.init();
    }

    brandNewslettercomponent.prototype.init = function () {
        this.bind();
    };

    brandNewslettercomponent.prototype.bind = function () {
        var _this = this;
        if (_this.inputFieldElement) {
            _this.inputFieldElement.addEventListener('blur', _this.validateInputField);
            _this.inputFieldElement.addEventListener('focus', _this.validateInputFieldOnFocus);
        }
        if (_this.emailSubmitButton) {
            _this.emailSubmitButton.addEventListener('click', _this.validateInputField);
            analytics.bind(_this.emailSubmitButton, [{
                functionName: 'analyticsBrandNewsLetterSubmit',
                event: 'click'
            }]);
        }
    };

    brandNewslettercomponent.prototype.validateInputField = function (evt) {
        var _this = this;

        if (_this.inputFieldElement && _this.inputFieldElement.value === '') {
            Utils.addClass(_this.inputFieldElement, 'nav-footer--invalidemail');
            Utils.addClass(_this.emailErrormsg, 'navfooter-brand-newsletter-signup-errormsg-none');
            Utils.removeClass(_this.alertIcon, 'navfooter-alertdiv');
            _this.inputFieldElement.removeEventListener('input', _this.validateInputField);
            evt.preventDefault();
        }

        else {
            if (/^[a-z\d._\+%&amp;\'\/=~$*?!`\-]+@[a-z0-9.\-]+\.[a-z]{2,24}$/i.test(_this.inputFieldElement.value)) {
                Utils.addClass(_this.emailErrormsg, 'navfooter-brand-newsletter-signup-errormsg-none');
                Utils.removeClass(_this.alertIcon, 'navfooter-alertdiv');
                Utils.removeClass(_this.inputFieldElement, 'nav-footer--invalidemail');
            }
            else {
                Utils.addClass(_this.inputFieldElement, 'nav-footer--invalidemail');
                Utils.removeClass(_this.emailErrormsg, 'navfooter-brand-newsletter-signup-errormsg-none');
                Utils.addClass(_this.alertIcon, 'navfooter-alertdiv');
                _this.inputFieldElement.addEventListener('input', _this.validateInputField);
                evt.preventDefault();
            }
        }
    };

    brandNewslettercomponent.prototype.validateInputFieldOnFocus = function () {
        if (this.inputFieldElement.value === '' && (Utils.hasClass(this.inputFieldElement, 'nav-footer--invalidemail'))) {
            Utils.removeClass(this.inputFieldElement, 'nav-footer--invalidemail');
        }

    };

    return brandNewslettercomponent;
});




/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/js/brandNewslettercomponent.js
 **/